export function parseGeoCoderResult(data) {
  if (!data.length) {
    return [];
  }
  return data;
}

export function getSuggestUrl(opts) {
  return `https://autocomplete.geocoder.cit.api.here.com/6.2/suggest.json?query=${opts.query}&app_id=${opts.app_id}&app_code=${opts.app_code}&country=${opts.country}&language=de`;
}

export function getSuggestUrlWithCenter(opts) {
  return `https://autocomplete.geocoder.cit.api.here.com/6.2/suggest.json?query=${opts.query}&app_id=${opts.app_id}&app_code=${opts.app_code}&country=${opts.country}&language=de&prox=${opts.center.join(',')},${opts.radius}`;
}

export function getGeoCodingUrl(opts) {
  return `https://geocoder.cit.api.here.com/6.2/geocode.json?locationid=${opts.locationId}&jsonattributes=1&gen=9&app_id=${opts.app_id}&app_code=${opts.app_code}`;
}

export default {
  parseGeoCoderResult,
  getSuggestUrl,
  getGeoCodingUrl
}